import type { CartonKind } from './rows';

export type CartonListParams = { page: number; limit: number; search: string };

export const cartonKeys = {
  all: ['catalog-carton'] as const,
  lists: (kind: CartonKind) => [...cartonKeys.all, kind] as const,
  list: (kind: CartonKind, params: CartonListParams) =>
    [...cartonKeys.lists(kind), params] as const,
};
